<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <CCard class="p-1">
            <CCardBody>
                <CRow>
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="showFilters"
                        class="ml-3" />
                    <span class="ml-2">Фильтры</span>
                </CRow>
                <CRow v-if="showFilters" class="mt-3 mb-0">
                    <CCol cols="12" md="4" class="mb-2">
                        Для главной
                        <CSelect
                            :options="selectOptions"
                            :value.sync="filters.for_main_page"
                            size="sm"
                            style="margin-bottom: 0;"
                        />
                    </CCol>
                    <CCol cols="12" md="4" class="mb-2">
                        Карусель подборок
                        <CSelect
                            :options="selectOptions"
                            :value.sync="filters.for_selection_carousel"
                            size="sm"
                            style="margin-bottom: 0;"
                        />
                    </CCol>
                    <CCol cols="12" md="4" class="mb-2">
                        Что есть в МИРСИТИ
                        <CSelect
                            :options="selectOptions"
                            :value.sync="filters.for_mircity_banner"
                            size="sm"
                            style="margin-bottom: 0;"
                        />
                    </CCol>
                    <CCol cols="12" md="4" class="mb-2">
                        Показывать попап на главной
                        <CSelect
                            :options="selectOptions"
                            :value.sync="filters.for_popup_banner"
                            size="sm"
                            style="margin-bottom: 0;"
                        />
                    </CCol>
                    <CCol cols="12" md="4" class="mb-2">
                        Показывать в блоке ЛП
                        <CSelect
                            :options="selectOptions"
                            :value.sync="filters.for_assistant_block"
                            size="sm"
                            style="margin-bottom: 0;"
                        />
                    </CCol>
                    <CCol cols="12" md="4" class="mb-2">
                        Активен
                        <CSelect
                            :options="selectOptions"
                            :value.sync="filters.enabled"
                            size="sm"
                            style="margin-bottom: 0;"
                        />
                    </CCol>
                </CRow>
                <CRow v-if="showFilters" class="mt-3 mb-0">
                    <CCol
                        cols="12"
                        md="6"
                        class="mt-1">
                        <CButton
                            class="ml-0"
                            color="primary"
                            @click="applyFilters">Применить</CButton>
                        <CButton
                            class="ml-2"
                            color="secondary"
                            @click="resetFilters">Сбросить</CButton>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>

        <div class="flex items-center bg-gray-100">
            <div class="w-16" v-show="!filtersApplied"></div>
            <div class="w-2/12 py-2 px-2 font-bold">Место показа</div>
            <div class="w-1/12 py-2 font-bold">Поз. на <br />странице</div>
            <div class="w-2/12 py-2 px-2 font-bold">Код AppsFlyer</div>
            <div class="w-2/12 py-2 px-2 font-bold">Название акции</div>
            <div class="w-2/12 py-2 font-bold">Тип контента</div>
            <div class="w-2/12 py-2 font-bold">Открывается при клике</div>
            <div class="w-1/12 py-2 font-bold">Для <br />главной</div>
            <div class="w-1/12 py-2 font-bold">Карусель подборок</div>
            <div class="w-1/12 py-2 font-bold">Банер в профиле</div>
            <div class="w-1/12 py-2 font-bold">Что есть в МИРСИТИ</div>
            <div class="w-1/12 py-2 font-bold">Показывать попап на главной</div>
            <div class="w-1/12 py-2 font-bold">Показывать в блоке ЛП</div>
            <div class="w-1/12 py-2 font-bold">Активен</div>
        </div>

        <Draggable v-model="list" tag="div" v-show="!filtersApplied">
            <div
                v-for="item in list"
                :key="item.id"
                class="flex items-center border-t border-gray-300"
            >
                <div class="w-16 flex items-center justify-content-center">
                    <CIcon
                        :height="16"
                        :content="cilCursorMove"
                        class="handle" />
                </div>
                <div class="w-2/12 truncate px-2">
                    {{ routeNamesMap[item.route_name] }}
                </div>
                <div class="w-1/12 truncate px-2">
                    {{ noneZero(item.place) }}
                </div>
                <div class="w-2/12 truncate px-2">
                    {{ item.code }}
                </div>
                <div class="w-2/12 py-2">
                    <!-- <span
                        class="text-purple-700 cursor-pointer hover:underline"
                        :title="item.route_name"
                        @click="$emit('select', item.id)"
                    >{{ formatTitle(item.title) }}
                    </span> -->
                    <a
                        :href="`/banners/${item.id}`"
                        class="text-purple-700 cursor-pointer hover:underline"
                    >{{ formatTitle(item.title) }}
                    </a>
                </div>
                <div class="w-2/12 py-2">{{ contentTypesMap[item.content_type] }}</div>
                <div class="w-2/12 py-2">{{ typesMap[item.type] }}</div>
                <div class="w-1/12">
                    <CBadge :color="item.for_main_page ? 'success' : 'secondary'">
                        {{ item.for_main_page ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_selection_carousel ? 'success' : 'secondary'">
                        {{ item.for_selection_carousel ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_mircity_banner ? 'success' : 'secondary'">
                        {{ item.for_mircity_banner ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_popup_banner ? 'success' : 'secondary'">
                        {{ item.for_popup_banner ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_assistant_block ? 'success' : 'secondary'">
                        {{ item.for_assistant_block ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.enabled ? 'success' : 'secondary'">
                        {{ item.enabled ? "Да" : "Нет" }}
                    </CBadge>
                </div>

            </div>
        </Draggable>

        <div v-show="filtersApplied">
            <div
                v-for="item in filteredData"
                :key="item.id"
                class="flex items-center border-t border-gray-300"
            >
                <div class="w-2/12 truncate px-2">
                    {{ routeNamesMap[item.route_name] }}
                </div>
                <div class="w-1/12 truncate px-2">
                    {{ noneZero(item.place) }}
                </div>
                <div class="w-2/12 truncate px-2">
                    {{ item.code }}
                </div>
                <div class="w-2/12 py-2">
                    <!-- <span
                        class="text-purple-700 cursor-pointer hover:underline"
                        :title="item.route_name"
                        @click="$emit('select', item.id)"
                    >{{ formatTitle(item.title) }}
                    </span> -->
                    <a
                        :href="`/banners/${item.id}`"
                        class="text-purple-700 cursor-pointer hover:underline"
                    >{{ formatTitle(item.title) }}
                    </a>
                </div>
                <div class="w-2/12 py-2">{{ contentTypesMap[item.content_type] }}</div>
                <div class="w-2/12 py-2">{{ typesMap[item.type] }}</div>
                <div class="w-1/12">
                    <CBadge :color="item.for_main_page ? 'success' : 'secondary'">
                        {{ item.for_main_page ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_selection_carousel ? 'success' : 'secondary'">
                        {{ item.for_selection_carousel ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_mircity_banner ? 'success' : 'secondary'">
                        {{ item.for_mircity_banner ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_popup_banner ? 'success' : 'secondary'">
                        {{ item.for_popup_banner ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.for_assistant_block ? 'success' : 'secondary'">
                        {{ item.for_assistant_block ? "Да" : "Нет" }}
                    </CBadge>
                </div>
                <div class="w-1/12">
                    <CBadge :color="item.enabled ? 'success' : 'secondary'">
                        {{ item.enabled ? "Да" : "Нет" }}
                    </CBadge>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';
    const { formatDate } = require('../../utils/views');

    export default {
        components: {
            Draggable,
        },

        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            showFilters: false,
            filtersApplied: false,
            cilCursorMove,
            contentTypesMap: {
                'image': 'Изображение центрированое',
                'image_bg': 'Изображение как фон',
                'video_mp4': 'Видео в формате mp4',
                'video_webm': 'Видео в формате webm',
            },
            typesMap: {
                'none': 'Ничего',
                'link': 'Ссылка на страницу',
                'external_link': 'Внешняя ссылка',
                'list': 'Список бизнесов',
            },
            routeNamesMap: {
                'restaurant-list': 'Список ресторанов',
                'grocery-list': 'Список продуктовых магазинов',
                'pharmacy-list': 'Список аптек',
                'assistant-list': 'Список помощников',
            },
            filteredData: [],
            filters: {
                for_main_page: -1,
                for_selection_carousel: -1,
                for_mircity_banner: -1,
                for_popup_banner: -1,
                for_assistant_block: -1,
                enabled: -1,
            },
            selectOptions: [
                { label: 'Не важно', value: -1 },
                { label: 'Да', value: 1 },
                { label: 'Нет', value: 0 }
            ],
        }),

        computed: {
            list: {
                get() {
                    return this.data;
                },

                set(v) {
                    const updated = v.map((item, idx) => {
                        item.position = idx + 1
                        return item;
                    });

                    this.$emit('update:data', updated);
                }
            },
        },

        async mounted() {
            try {
                (await this.axios.get('/entities-type')).data.map(type => {
                    this.$set(this.routeNamesMap, `entity-list-${type.code}`, type.title);
                });
                this.filteredData = this.data;
            } catch (error) {
                this.$root.$emit('showError', 'Ошибка загрузки данных. ' + error);
            }
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            formatTitle(title) {
                return (title && title.trim()) ? title.trim() : 'Без названия';
            },
            noneZero(date) {
                return (date === 0 ? '' : date);
            },
            applyFilters() {
                this.filteredData = this.data.filter(item => {
                    let show = true;
                    if (this.filters.for_main_page >= 0 && this.filters.for_main_page != item.for_main_page) {
                        show = false;
                    }
                    if (this.filters.for_selection_carousel >= 0 && this.filters.for_selection_carousel != item.for_selection_carousel) {
                        show = false;
                    }
                    if (this.filters.for_mircity_banner >= 0 && this.filters.for_mircity_banner != item.for_mircity_banner) {
                        show = false;
                    }
                    if (this.filters.for_popup_banner >= 0 && this.filters.for_popup_banner != item.for_popup_banner) {
                        show = false;
                    }
                    if (this.filters.for_assistant_block >= 0 && this.filters.for_assistant_block != item.for_assistant_block) {
                        show = false;
                    }
                    if (this.filters.enabled >= 0 && this.filters.enabled != item.enabled) {
                        show = false;
                    }
                    return show;
                });
                this.filtersApplied = true;
            },
            resetFilters() {
                this.filters = {
                    for_main_page: -1,
                    for_selection_carousel: -1,
                    for_mircity_banner: -1,
                    for_popup_banner: -1,
                    for_assistant_block: -1,
                    enabled: -1,
                };
                this.filteredData = this.data;
                this.filtersApplied = false;
                this.showFilters = false;
            }
        },
    };
</script>
